import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'
import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'

import { Button } from 'core-components/library/button'
import { IColumn } from 'core-components/library/list/types'

import { baseColumns } from '../config'

interface IGetColumns {
  onSelect?: (item: IWWPartners) => Promise<void> | void
  onDelete?: (item: IWWPartners) => void
  extraColumns?: IColumn[]
  basePredefinedColumns?: IColumn[]
}
export const getColumns = ({
  onDelete,
  onSelect,
  extraColumns = [],
  basePredefinedColumns,
}: IGetColumns) => {
  const additionalColumns = []
  if (onSelect || onDelete) {
    additionalColumns.push({
      field: `SelectPartner`,
      title: '',
      priority: 7,
      hideSettings: true,
      renderFunction: (item: IWWPartners) => {
        return (
          <div>
            <RenderWhen condition={Boolean(onSelect)}>
              <Button
                variant={'text'}
                iconButton={'kbase kbase-add'}
                onClick={() => onSelect!(item)}
              />
            </RenderWhen>
            <RenderWhen condition={Boolean(onDelete)}>
              <Button
                iconButton={'kbase kbase-delete-alt'}
                variant={'text'}
                color={'danger'}
                onClick={() => onDelete!(item)}
              />
            </RenderWhen>
          </div>
        )
      },
    })
  }

  if (basePredefinedColumns) {
    return [...basePredefinedColumns, ...additionalColumns, ...extraColumns]
  }
  return [...baseColumns, ...additionalColumns, ...extraColumns]
}
